// src/data/transducersData.js - Contains all transducer product data
import { getPriceComparisonUrl } from '../utils/productUrlMapping';

export const transducersData = [
  {
    id: "livescope-plus-lvs34",
    name: "Garmin LiveScope Plus LVS34",
    type: "livescope",
    msrp: 1799.99,
    csvLookupId: "LiveScope Plus LVS34",
    powerDraw12V: "1.7",
    peakPowerDraw: "4.8 A",
    sonarFrequency: "530–1100 kHz",
    image: "/images/transducers/livescopeplus.jpg",
    fallbackImage: "/images/transducers/livescopeplus.jpg",
    description: `Best All-Around | Most Popular | Top Clarity\nThe gold standard for real-time sonar. Incredible clarity and separation make it ideal for most fishing styles.\n✅ Great for seeing fish and structure clearly at typical freshwater depths.\n✅ Best balance of detail, performance, and versatility.`,
    notes: "Ideal for anglers wanting the clearest possible live imaging with excellent detail at moderate ranges. Best all-around live imaging option for most fishing situations.",
    maxRange: "200 ft",
    maxRangeSaltwater: "~170 ft",
    targetSeparation: "~14″ at 100 ft",
    beamAngle: "20° x 135° field of view",
    blackBoxRequired: true,
    blackBoxModel: "GLS 10 module",
    dimensions: "6.4″ × 3.1″ × 1.9″",
    releaseYear: "2022",
    imagingModes: "Forward, Down, Perspective",
    mountingIncluded: "Yes, with perspective mount option",
    priceComparisonUrl: getPriceComparisonUrl("LiveScope Plus LVS34")
  },
  {
    id: "livescope-xr-lvs62",
    name: "Garmin LiveScope XR LVS62",
    type: "livescope",
    msrp: 2999.99,
    csvLookupId: "LiveScope XR LVS62",
    powerDraw12V: "1.7",
    peakPowerDraw: "4.8 A",
    sonarFrequency: "265–550 kHz",
    image: "https://cdn11.bigcommerce.com/s-ktouu2lc/images/stencil/original/products/64773/95213/Garmin-LiveScope-XR-System-wGLS-10-LVS62-Transducer-010-02719-00_84053__33587.1715874993.jpg",
    fallbackImage: "https://cdn11.bigcommerce.com/s-ktouu2lc/images/stencil/original/products/64773/95213/Garmin-LiveScope-XR-System-wGLS-10-LVS62-Transducer-010-02719-00_84053__33587.1715874993.jpg",
    description: "Extended Range LiveScope designed specifically for deep/open water applications, with range capabilities more than double standard LiveScope.",
    notes: "The ultimate choice for offshore and deep water fishing where maximum range is critical. Great for finding structure and fish in deeper waters or locating schools at greater distances.",
    maxRange: "500 ft",
    maxRangeSaltwater: "~350 ft",
    targetSeparation: "~22″ at 100 ft",
    beamAngle: "20° x ~135° (narrow beam)",
    blackBoxRequired: true,
    blackBoxModel: "GLS 10 module",
    dimensions: "8.2″ × 4.0″ × 2.8″",
    releaseYear: "2022",
    imagingModes: "Forward, Down, Perspective",
    mountingIncluded: "Yes, with perspective mount option",
    priceComparisonUrl: getPriceComparisonUrl("LiveScope XR LVS62")
  },
  {
    id: "livescope-2-lvs44",
    name: "Garmin LiveScope 2 LVS44",
    type: "livescope",
    msrp: 1999.99,
    csvLookupId: "LiveScope 2 LVS44",
    powerDraw12V: "1.7",
    peakPowerDraw: "7.5 A",
    sonarFrequency: "600–1,050 kHz",
    image: "/images/transducers/livescope-2-lvs44.jpg",
    fallbackImage: "/images/transducers/livescope-2-lvs44.jpg",
    description: "LiveScope 2 transducer with 20% higher resolution and extended range out to 250 feet. Connects directly to compatible Garmin chartplotters without a black box.",
    notes: "Best for anglers who want maximum range in open water and deep structure fishing.",
    maxRange: "250 ft",
    beamAngle: "20° x 165° forward, 20° x 180° down/perspective",
    blackBoxRequired: false,
    dimensions: "6.3″ × 5.6″ × 1.9″",
    releaseYear: "2026",
    imagingModes: "Forward, Down, Perspective",
    mountingIncluded: "Yes, trolling motor barrel mount and perspective mount",
    priceComparisonUrl: getPriceComparisonUrl("LiveScope 2 LVS44")
  },
  {
    id: "livescope-2-lvs42hd",
    name: "Garmin LiveScope 2 HD LVS42HD",
    type: "livescope",
    msrp: 2199.99,
    csvLookupId: "LiveScope 2 HD LVS42HD",
    powerDraw12V: "1.7",
    peakPowerDraw: "7.5 A",
    sonarFrequency: "850–1,600 kHz",
    image: "/images/transducers/livescope-2-lvs42hd.jpg",
    fallbackImage: "/images/transducers/livescope-2-lvs42hd.jpg",
    description: "Garmin's clearest live sonar with 50% more detail at closer ranges out to 125 feet. Direct-connect LiveScope 2 HD transducer with no black box required.",
    notes: "Best for anglers who prioritize maximum detail at castable distances.",
    maxRange: "125 ft",
    beamAngle: "20° x 165° forward, 20° x 180° down/perspective",
    blackBoxRequired: false,
    dimensions: "5.2″ × 5.3″ × 1.9″",
    releaseYear: "2026",
    imagingModes: "Forward, Down, Perspective",
    mountingIncluded: "Yes, trolling motor barrel mount and perspective mount",
    priceComparisonUrl: getPriceComparisonUrl("LiveScope 2 HD LVS42HD")
  },
  {
    id: "livescope-2-lvs42hd-ice",
    name: "Garmin LiveScope 2 HD Ice Fishing Transducer LVS42HD-IF",
    type: "livescope",
    msrp: 2199.99,
    csvLookupId: "LiveScope 2 HD LVS42HD-IF",
    sonarFrequency: "850–1,600 kHz",
    image: "/images/transducers/livescope-2-lvs42hd-ice.jpg",
    fallbackImage: "/images/transducers/livescope-2-lvs42hd-ice.jpg",
    description: "LiveScope 2 HD ice fishing transducer with the same high-definition sonar as the LVS42HD, packaged with a shorter flexible cold-water cable and 0-degree shaft mount.",
    notes: "Ice fishing version of the LVS42HD with cold-weather cable and ice mount included.",
    maxRange: "125 ft",
    blackBoxRequired: false,
    releaseYear: "2026",
    imagingModes: "Forward, Down, Perspective",
    mountingIncluded: "Yes, 0-degree shaft mount",
    priceComparisonUrl: getPriceComparisonUrl("LiveScope 2 HD LVS42HD-IF")
  },
  {
    id: "panoptix-ps22",
    name: "Garmin Panoptix PS22-TR",
    type: "livescope",
    msrp: 999.99,
    csvLookupId: "Panoptix PS22",
    powerDraw12V: "0.7",
    peakPowerDraw: "4.0 A (fused)",
    sonarFrequency: "417 kHz",
    image: "https://res.garmin.com/en/products/010-01945-00/g/cf-lg.jpg",
    fallbackImage: "https://res.garmin.com/en/products/010-01945-00/g/cf-lg.jpg",
    description: "Versatile live-scanning sonar that offers both forward and downward views with a simple one-knob adjustment - a great entry point to live sonar technology.",
    notes: "More affordable than LiveScope with simplified installation (no black box required). Perfect for trolling motor mounting and ideal for anglers who want real-time fish tracking without complex setup.",
    maxRange: "100 ft (forward), 300 ft (down)",
    maxRangeSaltwater: "~80 ft (forward), ~240 ft (down)",
    targetSeparation: "Good but lower than LiveScope",
    beamAngle: "20° x 100° field of view",
    blackBoxRequired: false,
    dimensions: "1.3″ × 4.6″ × 3.8″",
    releaseYear: "2017",
    imagingModes: "Forward, Down (LiveVü)",
    mountingOption: "Trolling motor (shaft or head)",
    mountingIncluded: "Yes, trolling motor mount with pivot",
    priceComparisonUrl: getPriceComparisonUrl("Panoptix PS22")
  },
  {
    id: "panoptix-ps30-down",
    name: "Garmin Panoptix PS30 Down",
    type: "livescope",
    msrp: 1599.99,
    csvLookupId: "Panoptix PS30",
    powerDraw12V: "0.8",
    sonarFrequency: "~417 kHz",
    image: "https://res.garmin.com/en/products/010-01284-00/g/cf-lg.jpg",
    fallbackImage: "https://res.garmin.com/en/products/010-01284-00/g/cf-lg.jpg",
    description: "Down-looking sonar with 360° coverage that shows a real-time view of fish and structure passing beneath your boat.",
    notes: "Great for stationary fishing and scanning directly below. Lower power consumption than LiveScope systems and no black box required for simpler installation.",
    maxRange: "300 ft",
    maxRangeSaltwater: "~240 ft",
    targetSeparation: "Coarser resolution",
    beamAngle: "~90° vertical, 180° wide under boat",
    blackBoxRequired: false,
    dimensions: "~6.7″ × 3.6″ × 1.7″",
    releaseYear: "2015",
    imagingModes: "Down (live & 3D modes)",
    mountingIncluded: "Yes, through-hull mount",
    priceComparisonUrl: getPriceComparisonUrl("Panoptix PS30")
  },
  {
    id: "gt54uhd-chirp",
    name: "Garmin GT54UHD",
    type: "openWater",
    msrp: 369.99,
    csvLookupId: "GT54UHD",
    powerDraw12V: "0.25-0.4",
    peakPowerDraw: "2.5 A",
    sonarFrequency: "CHIRP 50/200 kHz",
    image: "https://m.media-amazon.com/images/I/41ed8S3fOxL._AC_UF894,1000_QL80_.jpg",
    fallbackImage: "https://m.media-amazon.com/images/I/41ed8S3fOxL._AC_UF894,1000_QL80_.jpg",
    description: "High-definition CHIRP sonar for open water fishing with excellent target separation and deep water capability.",
    notes: "Great for deep water fishing with clear target identification. CHIRP technology provides superior clarity over traditional sonar.",
    maxRange: "3,000 ft (depth)",
    maxRangeSaltwater: "~2,400 ft",
    targetSeparation: "2.5 inches at 100 ft",
    beamAngle: "24° at -10dB (50 kHz), 11° at -10dB (200 kHz)",
    blackBoxRequired: false,
    dimensions: "4.3″ × 13.4″ × 1.8″",
    releaseYear: "2020",
    imagingModes: "CHIRP, Traditional",
    mountingIncluded: "Transom mount bracket",
    installationType: "Transom mount",
    bestFor: "Deep Water Fishing",
    benefits: [
      "Crystal clear fish arches with CHIRP technology",
      "Excellent performance in deep freshwater and saltwater",
      "Reliable target separation down to 2.5 inches"
    ],
    priceComparisonUrl: getPriceComparisonUrl("GT54UHD")
  },
  {
    id: "gt56uhd-chirp",
    name: "Garmin GT56UHD",
    type: "openWater",
    msrp: 474.99,
    csvLookupId: "GT56UHD",
    powerDraw12V: "0.3-0.5",
    peakPowerDraw: "3.0 A",
    sonarFrequency: "CHIRP 50/200 kHz + Ultra High Definition",
    image: "/images/transducers/gt56uhd-chirp.jpg",
    fallbackImage: "/images/transducers/gt56uhd-chirp.jpg",
    description: "Premium CHIRP sonar with Ultra High Definition scanning and wider coverage area for comprehensive fish finding.",
    notes: "Excellent for scanning larger areas with ultra-clear definition. Perfect for finding fish over structure and in varying depths.",
    maxRange: "3,000 ft (depth)",
    maxRangeSaltwater: "~2,400 ft",
    targetSeparation: "2.0 inches at 100 ft",
    beamAngle: "24° at -10dB (50 kHz), 11° at -10dB (200 kHz) + Ultra Wide",
    blackBoxRequired: false,
    dimensions: "4.3″ × 13.4″ × 1.8″",
    releaseYear: "2021",
    imagingModes: "Ultra High Definition CHIRP, Traditional, ClearVü",
    mountingIncluded: "Transom mount bracket",
    installationType: "Transom mount",
    bestFor: "Versatile Fishing",
    benefits: [
      "Ultra High Definition for the clearest traditional sonar available",
      "Built-in ClearVü scanning sonar for detailed bottom structure",
      "Wider coverage area to locate fish faster"
    ],
    priceComparisonUrl: getPriceComparisonUrl("GT56UHD")
  },
  {
    id: "gt10hn-if",
    name: "Garmin GT10HN-IF",
    type: "iceFisher",
    msrp: 169.99,
    csvLookupId: "GT10HN-IF",
    powerDraw12V: "0.2-0.3",
    peakPowerDraw: "1.5 A",
    sonarFrequency: "50/200 kHz",
    image: "https://assets.basspro.com/image/list/fn_select:jq:first(.%5B%5D%7Cselect(.public_id%20%7C%20endswith(%22main%22)))/4934670.json?$Prod_PLPThumb$",
    fallbackImage: "https://assets.basspro.com/image/list/fn_select:jq:first(.%5B%5D%7Cselect(.public_id%20%7C%20endswith(%22main%22)))/4934670.json?$Prod_PLPThumb$",
    description: "Compact ice fishing transducer designed for portable use with clear target definition in shallow to medium depths.",
    notes: "Perfect for ice fishing in shallow to medium depths with reliable performance in cold conditions.",
    maxRange: "1,500 ft (depth)",
    targetSeparation: "2.5 inches at 50 ft",
    beamAngle: "9° at -10dB (200 kHz), 22° at -10dB (50 kHz)",
    blackBoxRequired: false,
    dimensions: "2.1″ × 1.9″ × 1.4″",
    releaseYear: "2019",
    imagingModes: "Traditional Sonar",
    mountingIncluded: "Ice fishing transducer float",
    installationType: "Portable ice transducer",
    bestFor: "Shallow/Medium Ice Fishing",
    benefits: [
      "Compact design perfect for ice fishing portability",
      "Reliable performance in freezing conditions",
      "Clear fish separation in shallow water"
    ],
    priceComparisonUrl: getPriceComparisonUrl("GT10HN-IF")
  },
  {
    id: "gt8hw-if",
    name: "Garmin GT8HW-IF",
    type: "iceFisher",
    msrp: 129.99,
    csvLookupId: "GT8HW-IF",
    powerDraw12V: "0.15-0.25",
    peakPowerDraw: "1.2 A",
    sonarFrequency: "50/200 kHz",
    image: "/images/transducers/gt8hw-if.jpg",
    fallbackImage: "/images/transducers/gt8hw-if.jpg",
    description: "Wide-beam ice fishing transducer with larger coverage area for locating fish efficiently under the ice.",
    notes: "Great for locating fish in a wider area under the ice with excellent coverage for ice fishing applications.",
    maxRange: "1,200 ft (depth)",
    targetSeparation: "3.0 inches at 50 ft",
    beamAngle: "28° at -10dB (50 kHz), 14° at -10dB (200 kHz)",
    blackBoxRequired: false,
    dimensions: "2.3″ × 2.1″ × 1.5″",
    releaseYear: "2018",
    imagingModes: "Traditional Sonar",
    mountingIncluded: "Ice fishing transducer float",
    installationType: "Portable ice transducer",
    bestFor: "Wide Coverage Ice Fishing",
    benefits: [
      "Wide beam coverage for finding fish faster",
      "Excellent for scanning larger areas under ice",
      "Budget-friendly option for ice fishing"
    ],
    priceComparisonUrl: getPriceComparisonUrl("GT8HW-IF")
  }
  // Add more transducers as needed
];